/* pdp-master.js — WS-PDP master PDP behaviour. Vanilla, no libraries, no observers for reveals (motion lives in plentum-motion.js).
   Buy box (size / purchase option / frequency → price, price per day, CTA, sticky bar, hidden selling_plan), gallery dots,
   delivery estimate, dose calculator, ingredient + FAQ accordions, 12-week timeline stage, one-click "pairs with" add. */
(function () {
  'use strict';
  if (window.__pdpMaster) return;
  window.__pdpMaster = true;
  var d = document;
  function $(s, c) { return (c || d).querySelector(s); }
  function $$(s, c) { return [].slice.call((c || d).querySelectorAll(s)); }
  function lower(s) { return (s || '').toLowerCase(); }
  function txt(el, v) { if (el && el.textContent !== v) el.textContent = v; }
  var STORE = null; // { V, byId, st, render, root }

  /* ───────────── dog's plan (research/19 section 3.1): localStorage plentum_plan_v1, written by the WS-GLOBAL engine and by the compact finder below ─────────────
     {v:1, concern:'gut|calm|itch|weight|daily', band:'u20|21-25|26-50|51-75|o75', formula:'<handle>', name:null|'Copper', src, step, created, updated}.
     Every read and write is wrapped: the page works without storage. A change broadcasts a 'plentum:plan' CustomEvent (document). */
  var PLAN_KEY = 'plentum_plan_v1';
  var BANDS = [{ k: 'u20', t: 'Under 20 lb' }, { k: '21-25', t: '20–25 lb' }, { k: '26-50', t: '26–50 lb' }, { k: '51-75', t: '51–75 lb' }, { k: 'o75', t: 'Over 75 lb' }];
  var BAND_NEW = { 'u20': 0, '21-25': 0, '26-50': 1, '51-75': 2, 'o75': 3 };     // Under 25 / 26-50 / 51-75 / Above 75 lbs
  var BAND_HERO = { 'u20': 0, '21-25': 1, '26-50': 1, '51-75': 2, 'o75': 2 };    // Under 20 / 20-50 / Over 50 lbs
  var FORMULAS = { gut: ['advanced-k9-gut-restore', 'Gut Restore'], calm: ['advanced-k9-calming-care', 'Calming Care'], itch: ['advanced-k9-itch-immune-care', 'Itch & Immune Care'],
    weight: ['advanced-k9-metabolic-care', 'Metabolic Care'], daily: ['all-in-one-dog-powder-supplement', 'Microbiome Care'] };
  function bandLabel(k) { for (var i = 0; i < BANDS.length; i++) if (BANDS[i].k === k) return BANDS[i].t; return ''; }
  function bandIdx(k, n) { var m = n === 3 ? BAND_HERO : BAND_NEW; return m.hasOwnProperty(k) ? Math.min(m[k], n - 1) : -1; }
  /* The WS-GLOBAL engine (window.PlentumPlan, EXECUTION/JOURNEY-API.md) owns the plan when it is loaded; without it we read and write the same localStorage key. */
  function engine() { var E = window.PlentumPlan; return E && typeof E.get === 'function' && typeof E.set === 'function' ? E : null; }
  function readPlan() {
    try { var E = engine(); if (E) { var g = E.get(); if (g) return g; } } catch (e) {}
    try { var p = JSON.parse(localStorage.getItem(PLAN_KEY)); return p && p.v === 1 ? p : null; } catch (e) { return null; }
  }
  function writePlan(patch) {
    try { var E = engine(); if (E) { E.set({ concern: patch.concern, band: patch.band, name: patch.name, src: patch.src }); return; } } catch (e) {}
    try { var p = readPlan() || { v: 1, created: Date.now() }; for (var k in patch) if (patch[k] !== undefined) p[k] = patch[k]; p.v = 1; p.updated = Date.now(); localStorage.setItem(PLAN_KEY, JSON.stringify(p)); } catch (e) {}
    try { d.dispatchEvent(new CustomEvent('plentum:plan', { detail: readPlan() })); } catch (e) {}
  }
  function pageHandle() { return location.pathname.split('/').pop(); }
  function pageConcern() { var h = pageHandle(); for (var c in FORMULAS) if (FORMULAS[c][0] === h) return c; return null; }
  function planConcern(p) { if (!p) return null; if (p.concern && FORMULAS[p.concern]) return p.concern; if (p.formula) for (var c in FORMULAS) if (FORMULAS[c][0] === p.formula) return c; return null; }
  function planName(p) { return p && p.name ? String(p.name).replace(/[<>]/g, '').slice(0, 20) : ''; }
  function perDay(v) { return v.sa + ' sachet' + (v.sa > 1 ? 's' : '') + ' a day'; }
  function mismatchNode(p) {
    if (p && Array.isArray(p.formulas) && p.formulas.indexOf(pageHandle()) >= 0) return null;   // "Your answers pointed to Gut Restore. Compare →" (null when the plan matches this page)
    var pc = planConcern(p), me = pageConcern(); if (!pc || !me || pc === me) return null;
    var f = d.createDocumentFragment(); f.appendChild(d.createTextNode('Your answers pointed to ' + FORMULAS[pc][1] + '. '));
    var a = d.createElement('a'); a.href = '/products/' + FORMULAS[pc][0]; a.textContent = 'Compare →'; f.appendChild(a); return f;
  }

  /* ───────────── buy box ───────────── */
  function initBuybox(root) {
    if (root._pdp) return;
    var dataEl = $('[data-pdp-data]', root); if (!dataEl) return;
    var V; try { V = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var byId = {}; V.forEach(function (v) { byId[v.id] = v; });
    var idIn = $('[data-pdp-id]', root), planIn = $('[data-pdp-plan]', root);
    var st = { vid: idIn ? +idIn.value : V[0].id, mode: root.getAttribute('data-mode') || 'sub', pi: 0 };
    root._pdp = st;
    /* J-P1: arriving with a plan -> the size for the dog's weight band is selected; the purchase option is NOT touched (one-time stays the default).
       An explicit ?variant= in the link always wins (read before the first render rewrites the URL). */
    var hadVariant = /[?&]variant=\d+/.test(location.search), plan0 = readPlan();
    /* T-LIFECYCLE: an email link ?band=u20|21-25|26-50|51-75|o75 selects the matching size (same mapping as a stored plan) and saves the band to the plan. Unknown values are ignored. No name or weight is sent anywhere. */
    var urlBand = (function () { try { var b = new URLSearchParams(location.search).get('band'); return b && BAND_NEW.hasOwnProperty(b) ? b : null; } catch (e) { return null; } })();
    if (urlBand && (!plan0 || plan0.band !== urlBand)) {
      var pc0 = pageConcern(), pp = { band: urlBand, src: 'email' }; if (pc0) pp.concern = pc0;
      try { var E0 = engine(); if (E0) E0.set(pp); else writePlan(pp); } catch (e) {}
      plan0 = readPlan() || { band: urlBand };
    }
    var bandKey = urlBand, confirmedBand = urlBand;
    if (bandKey && !hadVariant) { var bi = bandIdx(bandKey, V.length); if (V[bi] && V[bi].av) st.vid = V[bi].id; }
    var cur = byId[st.vid] || V[0];
    // default frequency = the first plan that delivers one box
    (cur.pl || []).some(function (p, i) { if (p.b === 1) { st.pi = i; return true; } });
    var el = {
      price: $('[data-pdp-price]', root), was: $('[data-pdp-was]', root), per: $('[data-pdp-per]', root), alt: $('[data-pdp-alt]', root), supply: $('[data-pdp-supply]', root),
      oneP: $('[data-pdp-one-p]', root), subP: $('[data-pdp-sub-p]', root), subW: $('[data-pdp-sub-w]', root), save: $('[data-pdp-save]', root),
      subS: $('[data-pdp-sub-s]', root), freq: $('[data-pdp-freq]', root), freqWrap: $('[data-pdp-freq-wrap]', root),
      cta: $('[data-pdp-cta]', root), ctaT: $('[data-pdp-cta-t]', root), ctaS: $('[data-pdp-cta-s]', root), micro: $('[data-pdp-micro]', root),
      oneW: $('[data-pdp-one-w]', root), wasL: $('[data-pdp-was-l]', root), code: $('[data-pdp-code]', root), sName: $('[data-pdp-sticky-name]', root), sLine: $('[data-pdp-sticky-line]', root), sBtn: $('[data-pdp-sticky-btn]', root), sticky: $('[data-pdp-sticky]', root)
    };
    var modes = $$('[data-pdp-mode]', root), sizes = $$('[data-pdp-size]', root);
    function loLive() { return root.getAttribute('data-lo-live') === '1' && d.documentElement.getAttribute('data-lo') !== 'ended'; }

    function render(silent) {
      var v = byId[st.vid]; if (!v) return;
      var pl = v.pl || [], p = pl[st.pi] || pl[0] || null;
      if (!p) st.mode = 'one';
      var sub = st.mode === 'sub' && !!p;
      /* T-PDPV3 decision 1: LAUNCH25 price on one-time purchases of launch products while the offer is live (data-lo-live from Liquid; html[data-lo] from launch-offer.js) */
      var loOn = loLive(), lo = loOn && !sub && !!v.lo;
      txt(el.price, sub ? p.pf : lo ? v.lo : v.pf);
      txt(el.supply, v.sa + ' box' + (v.sa > 1 ? 'es' : '') + ' · ' + (v.sa * 30) + ' sachets · 30-day supply');
      if (el.was) { el.was.hidden = lo ? false : (!sub || !p.wf || p.pc < 1); txt(el.was, lo ? v.pf : sub ? p.wf : ''); }
      if (el.wasL) el.wasL.hidden = el.was ? el.was.hidden : true;
      if (el.code) el.code.hidden = !lo;
      txt(el.per, (sub ? p.pd : lo ? v.lpd : v.pd) + '/day');
      V.forEach(function (x) {
        var xp = sub && x.pl[st.pi] ? x.pl[st.pi] : null, xl = loOn && !sub && x.lo, s = $('[data-pdp-sd="' + x.id + '"]', root), sd = $('[data-pdp-sdd="' + x.id + '"]', root);
        if (s) txt(s, x.av ? (xp ? xp.pf : xl ? x.lo : x.pf) : 'Sold out');
        if (sd) txt(sd, (xp ? xp.pd : xl ? x.lpd : x.pd) + ' a day');   /* T-PDPCRO item 5: price per day on every size card */
      });
      txt(el.oneP, loOn && v.lo ? v.lo : v.pf);
      txt(el.oneW, loOn && v.lo ? v.pf : '');
      if (p) {
        txt(el.subP, p.pf); txt(el.subW, p.pc > 0 ? p.wf : '');
        if (el.save) { el.save.hidden = p.pc < 1; txt(el.save, p.pc + '% off'); }
        /* T-PDPV3 decision 2: the plan's own saving, worded on the option (no new discount) */
        txt(el.subS, 'It ships free ' + lower(p.f) + (p.b > 1 ? ' (' + p.b + ' boxes, ' + p.bf + ' a box)' : '') + '.');
        if (el.freq) {
          el.freq.innerHTML = '';
          pl.forEach(function (x, i) {
            var o = d.createElement('option'); o.value = x.id; o.selected = i === st.pi;
            o.textContent = x.f + ' · ' + x.b + ' box' + (x.b > 1 ? 'es' : '') + ' · ' + x.pf + (x.b > 1 && x.pc > 0 ? ' (save ' + x.pc + '%)' : '');
            el.freq.appendChild(o);
          });
          if (el.freqWrap) el.freqWrap.hidden = pl.length < 2;
        }
      }
      modes.forEach(function (m) { m.checked = m.value === (sub ? 'sub' : 'one'); });
      sizes.forEach(function (s) { s.checked = +s.value === st.vid; });
      if (idIn) idIn.value = v.id;
      if (planIn) { planIn.value = p ? p.id : ''; planIn.disabled = !sub; }
      var ok = !!v.av;
      if (el.cta) { el.cta.disabled = !ok; }
      var po = root.getAttribute('data-po') === '1', poCta = root.getAttribute('data-po-cta') || 'Pre-order now';
      var ctaT = !ok ? 'Sold out' : sub ? (po ? 'Pre-order & subscribe · ' : 'Subscribe · ') + p.pf : (po ? poCta : 'Add to cart') + ' · ' + (lo ? v.lo : v.pf);
      txt(el.ctaT, ctaT);
      var poShip = root.getAttribute('data-po-ship') || 'Ships by Mon Oct 26';
      txt(el.micro, sub ? (po ? poShip + ', then ' : 'Renews ') + lower(p.f) + (p.b > 1 ? ' (' + p.b + ' boxes each delivery)' : '') + '. Skip, pause or cancel anytime.' : '');
      txt(el.sLine, v.t + ' · ' + (sub ? p.pf + ' a month' : lo ? v.lo : v.pf));   /* T-PDPCRO item 5: the sticky bar follows the selected size */
      if (el.sName) { var sp = readPlan(), sn = planName(sp), selectedBand = confirmedBand && sp && sp.band === confirmedBand && V[bandIdx(confirmedBand, V.length)] && V[bandIdx(confirmedBand, V.length)].id === st.vid; txt(el.sName, selectedBand ? (sn ? 'For ' + sn + ' · ' + bandLabel(sp.band) : 'For your ' + bandLabel(sp.band) + ' dog') : el.sName.getAttribute('data-default')); }
      txt(el.sBtn, !ok ? 'Sold out' : po ? poCta : sub ? 'Subscribe' : 'Add to cart');
      root.setAttribute('data-mode', sub ? 'sub' : 'one');
      try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u); } catch (e) {}
      if (!silent) d.dispatchEvent(new CustomEvent('pdp:change', { detail: { variant: v, mode: sub ? 'sub' : 'one', plan: p, index: V.indexOf(v) } }));
    }
    sizes.forEach(function (s) { s.addEventListener('change', function () { confirmedBand = null; st.vid = +s.value; render(); paintFor(); }); });
    modes.forEach(function (m) { m.addEventListener('change', function () { if (m.checked) { st.mode = m.value; render(); } }); });
    if (el.freq) el.freq.addEventListener('change', function () { st.pi = el.freq.selectedIndex; st.mode = 'sub'; render(); });
    if (el.sBtn) el.sBtn.addEventListener('click', function () { if (el.cta && !el.cta.disabled) el.cta.click(); });
    render(true);
    STORE = { V: V, byId: byId, st: st, render: render, root: root };

    /* J-P2: "For your dog" chip above the size picker, filled from the plan and the live variant data (never hard-coded) */
    var forEl = $('[data-pdp-for]', root), forT = $('[data-pdp-for-t]', root), forM = $('[data-pdp-for-m]', root);
    var forSub = $('[data-pdp-for-sub]', root);
    function paintFor() {
      if (!forEl) return;
      var p = readPlan(), v = confirmedBand && p && p.band === confirmedBand ? V[bandIdx(confirmedBand, V.length)] : null, mm = p ? mismatchNode(p) : null;
      if (v && v.id !== st.vid) v = null;
      /* PDPUX: the "For your dog" box shows only when the quiz recommendation is THIS product; otherwise a subtle link under the quiz link */
      if (forSub) { forSub.textContent = ''; if (mm) { forSub.appendChild(mm); forSub.hidden = false; } else forSub.hidden = true; }
      if (!v || mm) { forEl.classList.remove('is-on'); d.documentElement.classList.remove('pdp-has-plan'); return; }
      var nm = planName(p);
      txt(forT, (nm ? 'For ' + nm + ' · ' + bandLabel(p.band) : 'For your ' + bandLabel(p.band) + ' dog') + ': ' + perDay(v));
      if (forM) { forM.textContent = ''; forM.hidden = true; }
      forEl.classList.add('is-on'); d.documentElement.classList.add('pdp-has-plan');
    }
    paintFor();
    d.addEventListener('plentum:plan', function () {
      var latest = readPlan(); confirmedBand = latest && latest.band;
      var p = readPlan(), bi = p && p.band ? bandIdx(p.band, V.length) : -1;
      if (V[bi] && V[bi].av && st.vid !== V[bi].id) { st.vid = V[bi].id; render(); }
      else render(true);
      paintFor();
    });
    addEventListener('storage', function (e) { if (e.key === PLAN_KEY) { paintFor(); render(true); } });

    /* add to cart: our own request, so the Seal app's injected inputs can never change what is added */
    var form = $('[data-pdp-form]', root), errBox = $('[data-pdp-err]', root), errT = $('[data-pdp-err-t]', root);
    function fail(m) { if (errBox) { errBox.hidden = !m; if (errT) errT.textContent = m || ''; } }
    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault(); e.stopPropagation();
      if (!el.cta || el.cta.disabled || el.cta.getAttribute('aria-disabled') === 'true') return;
      var v = byId[st.vid], p = (v.pl || [])[st.pi], sub = st.mode === 'sub' && !!p, drawer = $('cart-drawer');
      var item = { id: v.id, quantity: 1 }; if (sub) item.selling_plan = p.id;
      var payload = { items: [item] }, secs = null;
      if (drawer && typeof drawer.getSectionsToRender === 'function') { secs = drawer.getSectionsToRender().map(function (x) { return x.id; }); payload.sections = secs; payload.sections_url = location.pathname; if (drawer.setActiveElement) drawer.setActiveElement(el.cta); }
      /* T-PDPV3 decision 1: a one-time add of a launch product applies LAUNCH25 to the cart (Ajax cart "discount"; the code's own rules in Shopify decide what it discounts). The drawer then renders the discounted cart. */
      var applyLo = loLive() && !sub;
      fail(''); el.cta.setAttribute('aria-disabled', 'true'); el.cta.classList.add('loading'); var sp = $('.loading-overlay__spinner', el.cta); if (sp) sp.classList.remove('hidden');
      fetch(((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(payload) })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) { fail(res.description || res.message || 'Could not add this item.'); return; }
          if (!applyLo) return res;
          var up = { discount: 'LAUNCH25' }; if (secs) { up.sections = secs; up.sections_url = location.pathname; }
          return fetch(((window.routes && window.routes.cart_update_url) || '/cart/update') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(up) })
            .then(function (r) { return r.ok ? r.json() : null; })
            .then(function (u) { if (u && u.sections) res.sections = u.sections; return res; }, function () { return res; });
        })
        .then(function (res) {
          if (!res) return;
          try { if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'pdp', productVariantId: v.id, cartData: res }); } catch (x) {}
          if (drawer && res.sections && typeof drawer.renderContents === 'function') drawer.renderContents(res, true);
          else location.href = (window.routes && window.routes.cart_url) || '/cart';
        })
        .catch(function () { fail('Something went wrong. Please try again.'); })
        .then(function () { el.cta.removeAttribute('aria-disabled'); el.cta.classList.remove('loading'); if (sp) sp.classList.add('hidden'); });
    }, true);

    /* short description: two lines on phones, "More" expands it */
    var dek = $('[data-pdp-dek]', root), more = $('[data-pdp-dek-more]', root);
    if (dek && more) {
      var p0 = dek.firstElementChild || dek;
      var over = function () { dek.classList.remove('is-open'); var clamped = p0.scrollHeight > p0.clientHeight + 2; more.hidden = !clamped; if (!clamped) dek.classList.add('is-open'); };
      over(); addEventListener('resize', function () { if (!dek.classList.contains('is-open') || more.getAttribute('aria-expanded') !== 'true') over(); });
      more.addEventListener('click', function () { var o = dek.classList.toggle('is-open'); more.setAttribute('aria-expanded', String(o)); more.textContent = o ? 'Less' : 'More'; });
    }

    /* gallery: slides after the first start as a placeholder (data-pdp-src); load each when it scrolls into view, and all of them on the first touch, key press or dot tap (T-GAPS2 P1-4) */
    var gal = $('[data-pdp-gal]', root), lazyImgs = gal ? $$('img[data-pdp-src]', gal) : [];
    if (lazyImgs.length) {
      var loadImg = function (im) {
        var s = im.getAttribute('data-pdp-src'); if (!s) return;
        var ss = im.getAttribute('data-pdp-srcset'); if (ss) im.srcset = ss;
        im.src = s; im.removeAttribute('data-pdp-src'); im.removeAttribute('data-pdp-srcset');
        if (io) io.unobserve(im);
      };
      var loadAll = function () { lazyImgs.forEach(loadImg); };
      var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) loadImg(e.target); }); }, { rootMargin: '0px 0px 300px 0px' }) : null;
      if (io) lazyImgs.forEach(function (im) { io.observe(im); }); else loadAll();
      ['pointerdown', 'touchstart', 'keydown', 'focusin'].forEach(function (t) { gal.addEventListener(t, loadAll, { once: true, passive: true }); });
    }

    /* gallery dots (phones) */
    var track = $('[data-pdp-track]', root), dots = $$('.pdp-gal__dot', root);
    if (track && dots.length) {
      var tick = 0;
      track.addEventListener('scroll', function () {
        if (tick) return; tick = requestAnimationFrame(function () {
          tick = 0; var i = Math.round(track.scrollLeft / (track.clientWidth || 1));
          dots.forEach(function (b, j) { if (j === i) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current'); });
        });
      }, { passive: true });
      dots.forEach(function (b) { b.addEventListener('click', function () { if (typeof loadAll === 'function') loadAll(); track.scrollTo({ left: +b.getAttribute('data-i') * track.clientWidth, behavior: 'smooth' }); }); });
    }

    /* sticky bar (CRO #5): shown only once the WHOLE buy box (price, sizes, options, CTA) is above the sticky site header, so it can never cover the price or the
       options; hidden again as soon as any part of the buy box is back in view, and while the footer is in view */
    if (el.sticky) {
      var sBox = $('[data-pdp-box]', root), sHead = d.querySelector('header.shopify-section-group-header-group') || d.querySelector('header');
      var sFoot = d.querySelector('footer, .shopify-section-group-footer-group'), sTick = 0, sOn = null;
      var sPaint = function () {
        sTick = 0;
        var hb = sHead ? Math.max(0, Math.round(sHead.getBoundingClientRect().bottom)) : 0;
        var out = !!sBox && sBox.getBoundingClientRect().bottom < hb + 2;
        var footIn = !!sFoot && sFoot.getBoundingClientRect().top < innerHeight;
        /* P1-8: on phones the bar shows from first paint, and any time the Pre-order / Add to cart button is outside the screen */
        if (matchMedia('(max-width: 749px)').matches && el.cta) { var cr = el.cta.getBoundingClientRect(); out = out || cr.top >= innerHeight || cr.bottom <= hb; }
        var on = out && !footIn;
        d.documentElement.classList.add('pdp-sticky-init');
        if (on === sOn) return; sOn = on;
        el.sticky.classList.toggle('is-on', on); el.sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
        d.documentElement.classList.toggle('pdp-sticky-on', on);      /* WS-GLOBAL plan pill hides while this is set (research/19 section 3.2) */
        try { d.dispatchEvent(new CustomEvent('plentum:sticky', { detail: { on: on } })); } catch (e) {}
        if (el.sBtn) el.sBtn.tabIndex = on ? 0 : -1;
      };
      var sSched = function () { if (!sTick) sTick = requestAnimationFrame(sPaint); };
      addEventListener('scroll', sSched, { passive: true }); addEventListener('resize', sSched);
      sPaint();
    }

    /* desktop: keep the sticky box fully reachable when it is taller than the viewport */
    var box = $('[data-pdp-box]', root);
    function fit() { if (!box) return; if (innerWidth < 900) { box.style.top = ''; return; } var h = box.offsetHeight, room = innerHeight - 92 - 16; box.style.top = (h > room ? Math.min(92, innerHeight - h - 16) : 92) + 'px'; }
    fit(); addEventListener('resize', fit);
    if ('ResizeObserver' in window && box) new ResizeObserver(fit).observe(box);

    /* delivery estimate: policy = 1–2 business days to process + 3–7 business days delivery; weekends skipped */
    var ship = $('[data-pdp-ship]', root);
    if (ship) {
      var out = $('[data-pdp-eta]', ship), lo = parseInt(ship.getAttribute('data-eta-min'), 10) || 4, hi = parseInt(ship.getAttribute('data-eta-max'), 10) || 9;
      var addBD = function (dt, n) { var x = new Date(dt.getTime()); while (n > 0) { x.setDate(x.getDate() + 1); var w = x.getDay(); if (w !== 0 && w !== 6) n--; } return x; };
      try { var f = function (x) { return x.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }); }, now = new Date(); if (out) out.textContent = f(addBD(now, lo)) + ' – ' + f(addBD(now, hi)); } catch (e) {}
    }
  }

  /* public API (dose calculator, pairs) */
  window.PDP = {
    select: function (id, scroll) {
      if (!STORE || !STORE.byId[id]) return;
      STORE.st.vid = +id; STORE.render();
      if (scroll) { var b = $('[data-pdp-box]', STORE.root); if (b) { b.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' }); try { b.focus({ preventScroll: true }); } catch (e) {} } }
    },
    state: function () { return STORE && STORE.st; }
  };

  /* ───────────── dose calculator ───────────── */
  /* sticky section tabs (phones): Benefits · Ingredients · How to use · Research · FAQ. Shown once the buy box has scrolled out, under the sticky site header;
     scroll-spy marks the section nearest the top; tabs whose section is missing on a page are hidden. */
  function initTabs(root) {
    var nav = $('[data-pdp-tabs]', root); if (!nav || nav._k) return; nav._k = 1;
    var box = $('[data-pdp-box]', root), scroller = $('[data-pdp-tabs-in]', nav);
    var sel = { benefits: '.pdp-who', ingredients: '.pdp-ing', use: '.pdp-dose', research: '.pdp-research', faq: '.pdp-faqsec' };
    var links = $$('[data-pdp-tab]', nav), tgt = {}, vis = [];
    links.forEach(function (a) {
      var key = a.getAttribute('data-pdp-tab'), t = d.querySelector(sel[key]);
      if (!t) { a.hidden = true; return; }
      if (!t.id) t.id = 'pdp-s-' + key;
      a.setAttribute('href', '#' + t.id); tgt[key] = t; vis.push(a);
    });
    if (vis.length < 3) return;
    nav.hidden = false;
    var header = d.querySelector('header.shopify-section-group-header-group') || d.querySelector('header');
    var foot = d.querySelector('footer, .shopify-section-group-footer-group');
    var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches, tick = 0, cur = null;
    function top() { var r = header ? header.getBoundingClientRect() : null; return r ? Math.max(0, Math.round(r.bottom)) : 0; }
    function update() {
      tick = 0;
      var off = top(), bb = box ? box.getBoundingClientRect() : null;
      var show = innerWidth < 900 && !!bb && bb.bottom < off + 8 && !(foot && foot.getBoundingClientRect().top < innerHeight - 40);
      nav.classList.toggle('is-on', show); nav.setAttribute('aria-hidden', show ? 'false' : 'true');
      vis.forEach(function (a) { a.tabIndex = show ? 0 : -1; });
      if (!show) return;
      nav.style.top = off + 'px';
      var line = off + nav.offsetHeight + 24, best = null, bestTop = -1e9;
      vis.forEach(function (a) { var t = tgt[a.getAttribute('data-pdp-tab')].getBoundingClientRect().top; if (t <= line && t > bestTop) { bestTop = t; best = a; } });
      vis.forEach(function (a) { if (a === best) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current'); });
      if (best && best !== cur) { cur = best; if (scroller) scroller.scrollTo({ left: best.offsetLeft - (scroller.clientWidth - best.offsetWidth) / 2, behavior: reduce ? 'auto' : 'smooth' }); }
    }
    function sched() { if (!tick) tick = requestAnimationFrame(update); }
    addEventListener('scroll', sched, { passive: true }); addEventListener('resize', sched);
    nav.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('[data-pdp-tab]') : null; if (!a) return;
      var t = tgt[a.getAttribute('data-pdp-tab')]; if (!t) return;
      e.preventDefault();
      var y = t.getBoundingClientRect().top + (window.pageYOffset || d.documentElement.scrollTop) - (top() + nav.offsetHeight + 6);
      window.scrollTo({ top: Math.max(0, y), behavior: reduce ? 'auto' : 'smooth' });
    });
    update();
  }

  /* J-P2: compact finder inside "Is it right for your dog?" (formula fixed -> one question: the dog's weight). It writes the same plan the WS-GLOBAL engine reads,
     selects the matching size in the buy box (one-time stays selected) and answers "Yes, a good fit" or "Your answers pointed to X. Compare →". */
  function initFinder(box) {
    if (box._k) return; box._k = 1;
    if (!STORE) return;
    var V = STORE.V, chips = $$('[data-band]', box), res = $('[data-pdp-find-res]', box);
    function show(band) {
      var ix = bandIdx(band, V.length), v = V[ix]; if (!v) return;
      chips.forEach(function (c) { var on = c.getAttribute('data-band') === band; c.setAttribute('aria-pressed', String(on)); c.classList.toggle('is-on', on); });
      var p = readPlan(), mm = mismatchNode(p), nm = planName(p);
      res.textContent = '';
      var b = d.createElement('strong'); b.textContent = mm ? '' : 'Yes, a good fit. '; if (!mm) res.appendChild(b);
      /* T-PDPLIVE B2: while LAUNCH25 is live on a launch product, the chip states the same basis as the buy box (LAUNCH25 one-time price per day, same math), with the regular price per day labeled. */
      var loOn = STORE.root.getAttribute('data-lo-live') === '1' && d.documentElement.getAttribute('data-lo') !== 'ended' && !!v.lpd;
      var pdTxt = loOn ? v.lpd + ' a day with LAUNCH25 on a one-time order (' + v.pd + ' a day at the regular price)' : v.pd + ' a day';
      res.appendChild(d.createTextNode((nm ? 'For ' + nm + ' · ' + bandLabel(band) : 'For your ' + bandLabel(band) + ' dog') + ': ' + perDay(v) + ', ' + pdTxt + '. '));
      if (mm) { var s = d.createElement('span'); s.className = 'pdp-find__mm'; s.appendChild(mm); res.appendChild(s); res.appendChild(d.createTextNode(' ')); }
      var go = d.createElement('button'); go.type = 'button'; go.className = 'pdp-find__go'; go.textContent = 'Choose my size ↑';
      go.addEventListener('click', function () { if (window.PDP) window.PDP.select(v.id, true); });
      res.appendChild(go); res.hidden = false;
    }
    chips.forEach(function (c) {
      c.addEventListener('click', function () {
        var band = c.getAttribute('data-band'), p = readPlan(), bi = bandIdx(band, V.length);
        var patch = { band: band, src: p && p.src ? p.src : 'pdp', step: Math.max((p && p.step) || 0, 2) };
        if (!p) { patch.concern = pageConcern() || undefined; patch.formula = pageHandle(); }
        writePlan(patch);
        if (V[bi] && V[bi].av && window.PDP) window.PDP.select(V[bi].id, false);
        show(band);
      });
    });
    var p0 = readPlan(); if (p0 && p0.band && /[?&]band=/.test(location.search)) show(p0.band);
    box.hidden = false;
  }

  function initCalc(box) {
    if (box._k) return; box._k = 1;
    var range = $('[data-pdp-w]', box), out = $('[data-pdp-wout]', box), big = $('[data-pdp-big]', box), sub = $('[data-pdp-bigsub]', box), go = $('[data-pdp-go]', box);
    var breaks = (box.getAttribute('data-breaks') || '25,50,75').split(',').map(Number);
    var tiers = $$('[data-pdp-tier]', box), cur = 0;
    function run() {
      if (!STORE) return;
      var w = +range.value, i = breaks.length; breaks.some(function (b, j) { if (j === 0 && box.hasAttribute('data-first-exclusive') ? w < b : w <= b) { i = j; return true; } });
      var v = STORE.V[Math.min(i, STORE.V.length - 1)]; if (!v) return; cur = v;
      var p = (v.pl || [])[0];
      out.innerHTML = w + '<small>lb</small>';
      big.innerHTML = '<b>' + v.sa + ' sachet' + (v.sa > 1 ? 's' : '') + '</b> a day';
      sub.textContent = v.pd + ' a day one-time' + (p ? ' · ' + p.pd + ' a day with Subscribe' : '') + ' · size: ' + v.t;
      if (go) go.textContent = 'Choose the ' + v.t + ' size';
      tiers.forEach(function (t, j) { t.classList.toggle('is-on', j === Math.min(i, tiers.length - 1)); });
      range.setAttribute('aria-valuetext', w + ' pounds: ' + v.sa + ' sachet' + (v.sa > 1 ? 's' : '') + ' a day');
    }
    range.addEventListener('input', run);
    if (go) go.addEventListener('click', function () { if (cur && window.PDP) window.PDP.select(cur.id, true); });
    run();
  }

  /* ───────────── accordions (ingredients, FAQ) ───────────── */
  function initAcc(list, rowSel, btnSel, exclusive) {
    if (list._k) return; list._k = 1;
    $$(btnSel, list).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var row = btn.closest(rowSel), open = !row.classList.contains('is-open');
        if (exclusive && open) $$(rowSel + '.is-open', list).forEach(function (r) { if (r !== row) { r.classList.remove('is-open'); var b = $(btnSel, r); if (b) b.setAttribute('aria-expanded', 'false'); } });
        row.classList.toggle('is-open', open); btn.setAttribute('aria-expanded', String(open));
        if (open) { var ph = $('img[data-src]', row); if (ph) { ph.src = ph.getAttribute('data-src'); ph.removeAttribute('data-src'); } }   /* ingredient macro photo: fetched on first open */
      });
      /* warm the photo on the first touch/hover so it is ready when the row opens */
      var warm = function () { var row = btn.closest(rowSel), ph = row && $('img[data-src]', row); if (ph) { var im = new Image(); im.src = ph.getAttribute('data-src'); } };
      btn.addEventListener('pointerenter', warm, { once: true }); btn.addEventListener('touchstart', warm, { once: true, passive: true });
    });
  }

  /* ───────────── 12-week timeline: show the phase that matches the week ───────────── */
  function initTimeline(box) {
    if (box._k) return; box._k = 1;
    var phs = $$('.pdp-tl__ph', box);
    function show(w) { phs.forEach(function (p) { var a = +p.getAttribute('data-from'), b = +p.getAttribute('data-to'); p.classList.toggle('is-on', w >= a && w <= b); }); }
    box.addEventListener('pm:week', function (e) { show(e.detail.week); });
    show(+(box.getAttribute('data-pm-start') || 1));
  }

  /* ───────────── pairs with: one-click AJAX add ───────────── */
  function initPair(card) {
    if (card._k) return; card._k = 1;
    // Pack image: if the product image fails (404, still processing), show the pack fallback instead of a blank tile.
    var pim = $('[data-pdp-pair-img]', card);
    if (pim) {
      var pfb = pim.getAttribute('data-fallback');
      var useFb = function () { if (pfb && pim.getAttribute('src') !== pfb) { pim.removeAttribute('srcset'); pim.removeAttribute('sizes'); pim.setAttribute('src', pfb); } };
      pim.addEventListener('error', useFb);
      if (pim.complete && pim.naturalWidth === 0) useFb();
    }
    var dataEl = $('[data-pdp-pair-data]', card), sel = $('[data-pdp-pair-size]', card), btn = $('[data-pdp-pair-add]', card), msg = $('[data-pdp-pair-msg]', card);
    if (!dataEl || !btn) return;
    var D; try { D = JSON.parse(dataEl.textContent); } catch (e) { return; }
    function mode() { return (STORE && STORE.st.mode === 'sub') ? 'sub' : 'one'; }
    function sync(fromMain) {
      if (fromMain && STORE && sel) { var i = Math.min(STORE.V.indexOf(STORE.byId[STORE.st.vid]), D.length - 1); if (i >= 0) sel.selectedIndex = i; }
      var v = D[sel ? sel.selectedIndex : 0] || D[0]; if (!v) return;
      var sub = mode() === 'sub' && v.plan;
      btn.disabled = !v.av;
      btn.textContent = !v.av ? 'Sold out' : sub ? 'Add & subscribe · ' + v.plan.pf + (v.plan.f ? ' ' + lower(v.plan.f) : '') : 'Add to cart · ' + v.pf;
      var pr = $('[data-pdp-pair-price]', card); if (pr) pr.textContent = (sub ? v.plan.pd : v.pd) + '/day';
    }
    if (sel) sel.addEventListener('change', function () { sync(false); });
    d.addEventListener('pdp:change', function () { sync(true); });
    sync(true);
    btn.addEventListener('click', function () {
      var v = D[sel ? sel.selectedIndex : 0] || D[0]; if (!v || btn.disabled) return;
      var sub = mode() === 'sub' && v.plan, drawer = $('cart-drawer'), item = { id: v.id, quantity: 1 };
      if (sub) item.selling_plan = v.plan.id;
      var payload = { items: [item] };
      if (drawer && typeof drawer.getSectionsToRender === 'function') { payload.sections = drawer.getSectionsToRender().map(function (s) { return s.id; }); payload.sections_url = location.pathname; }
      var label = btn.textContent; btn.disabled = true; if (msg) msg.textContent = '';
      fetch(((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload) })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) throw new Error(res.description || res.message || 'Could not add this item');
          try { if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'pdp-pair', cartData: res }); } catch (e) {}
          if (drawer && res.sections && typeof drawer.renderContents === 'function') drawer.renderContents(res, true);
          else location.href = (window.routes && window.routes.cart_url) || '/cart';
          btn.disabled = false; btn.textContent = label;
        })
        .catch(function (e) { btn.disabled = false; btn.textContent = label; if (msg) msg.textContent = e.message; });
    });
  }

  function initAll(scope) {
    scope = scope || d;
    $$('[data-pdp-bb]', scope).forEach(initBuybox);
    $$('[data-pdp-bb]', scope).forEach(initTabs);
    $$('[data-pdp-calc]', scope).forEach(initCalc);
    $$('[data-pdp-find]', scope).forEach(initFinder);
    $$('[data-pdp-ing]', scope).forEach(function (l) {
      initAcc(l, '.pdp-ing__row', '.pdp-ing__btn', true);
      if (!l._o) { l._o = 1; if (matchMedia('(min-width: 900px)').matches) { var f = $('.pdp-ing__row', l), b = f && $('.pdp-ing__btn', f); if (f && b && !f.classList.contains('is-open')) b.click(); } }
    });
    $$('[data-pdp-faq]', scope).forEach(function (l) { initAcc(l, '.pdp-faq__item', '.pdp-faq__q', false); });
    $$('[data-pdp-tl]', scope).forEach(initTimeline);
    $$('[data-pdp-pair]', scope).forEach(initPair);
    if (window.PM && typeof window.PM.init === 'function') window.PM.init(scope === d ? d : scope);
  }
  /* Seal renders its savings badge as "SAVE 11.11%": show it as "Save 11%" (T-GAPS2). Re-applied when Seal re-renders. */
  function tidySave() {
    var n = 0;
    $$('.sls-savings-badge').forEach(function (b) {
      var m = /^\s*save\s+([\d.]+)\s*%\s*$/i.exec(b.textContent || ''); n++;
      if (m) { var t = 'Save ' + Math.round(parseFloat(m[1])) + '%'; if (b.textContent !== t) b.textContent = t; }
    });
    return n;
  }
  function watchSave() {
    tidySave(); if (!('MutationObserver' in window) || !$('.sealsubs-container, [data-sls-selling_plan], .sls-option-container') && !d.querySelector('[class*="sls-"]') && !$('[data-pdp-box]')) return;
    var q = 0;
    new MutationObserver(function () { if (q) return; q = requestAnimationFrame(function () { q = 0; tidySave(); }); }).observe(d.body, { childList: true, subtree: true, characterData: true });
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', function () { initAll(); watchSave(); }); else { initAll(); watchSave(); }
  d.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  /* T-OWNERFIX-1020: buy-box "Questions owners ask" links open the matching question in the grouped FAQ (#pdp-faq) and move focus to it */
  d.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-oq-jump]');
    if (!a) return;
    var q = a.getAttribute('data-oq-jump'), row = null;
    $$('#pdp-faq .pdp-faq__item').forEach(function (r) { if (!row && r.getAttribute('data-q') === q) row = r; });
    if (!row) return;
    e.preventDefault();
    var btn = $('.pdp-faq__q', row);
    if (btn && !row.classList.contains('is-open')) btn.click();
    row.scrollIntoView({ block: 'center', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    if (btn) btn.focus({ preventScroll: true });
  });
})();
